import {provinceList} from "../config/provinceConfig";

export function provinceArea(areaCode) {
    return provinceList.find(item => (item.code === areaCode)) || provinceList[0];
}
